

















import {Vue, Component, Prop, Model} from 'vue-property-decorator';
import {SystemNode} from '@c/system/interfaces';

@Component({})
export default class SelectField extends Vue {
  // Возможность очистки поля
  @Prop({type: Boolean, default: false}) nullable!: boolean;

  // Заголовок поля
  @Prop() label!: string;

  // Callback для загрузки данных
  @Prop({required: true}) callbackLoadItems!: Function;

  // Показатель использования предустановленного значения
  // Выбирается первое из списка
  @Prop({required: false, default: false}) preset!: boolean;

  // Список элементов для выбора
  items: any[] = [];

  // Показатели загрузки и наличия ошибок
  presetLoading = false;

  error = false;

  // Модель для выбранного элемента
  @Model('change') _selectedItem!: any;

  get selectedItem() {
    return this._selectedItem;
  }

  set selectedItem(newSelectedItem: any) {
    this.$emit('change', newSelectedItem);
  }

  created() {
    if (this.preset) {
      this.presetLoading = true;
      this.callbackLoadItems()
        .then((items: SystemNode[]) => {
          if (items.length) {
            this.items = items;
            this.selectedItem = this.items[0];
          }
        })
        .catch(() => {
          this.error = true;
        })
        .finally(() => {
          this.presetLoading = false;
        });
    }
  }

  // Действия при очистке поля
  onClear() {
    this.selectedItem = null;
  }
}
